import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotWeatherInformationApiMeta } from "../apiMeta";
import {
  type CurrentWeatherForStationsInput,
  currentWeatherForStationsInputSchema,
} from "./shared/weatherInfo.input";
import {
  type WeatherInfo,
  weatherInfoSchema,
} from "./shared/weatherInfo.output";

/**
 * Metadata for the fetchCurrentWeatherForStations endpoint
 */
export const currentWeatherForStationsMeta = {
  functionName: "fetchCurrentWeatherForStations",
  endpoint: "/GetCurrentWeatherForStationsAsJson?StationList={StationList}",
  inputSchema: currentWeatherForStationsInputSchema,
  outputSchema: weatherInfoSchema.array(),
  sampleParams: { StationList: "1909,1966,1970" },
  endpointDescription:
    "Get current weather information for multiple specified stations.",
} satisfies EndpointMeta<CurrentWeatherForStationsInput, WeatherInfo[]>;

/**
 * Fetch function for retrieving current weather information for multiple specified stations
 */
const { fetch, useHook } = createFetchAndHook<
  CurrentWeatherForStationsInput,
  WeatherInfo[]
>({
  api: wsdotWeatherInformationApiMeta,
  endpoint: currentWeatherForStationsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/weatherInfo.endpoints").weatherInfoGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving current weather information for multiple specified stations
 */
export const fetchCurrentWeatherForStations: FetchFactory<
  CurrentWeatherForStationsInput,
  WeatherInfo[]
> = fetch;

/**
 * React Query hook for retrieving current weather information for multiple specified stations
 */
export const useCurrentWeatherForStations: HookFactory<
  CurrentWeatherForStationsInput,
  WeatherInfo[]
> = useHook;
